import React, { useState, useEffect } from "react";
import { Select, Label, ErrorMessage } from "./FormStyles";
import Spinner from "../Common/Spinner";
import useEmpresa from "../../hooks/useEmpresa";
import CheckRender from "../Common/CheckRender";
import { validationSchemaRequired } from "../../utils/SchemaValidations";
import { isEmptyValue } from "../../utils/StringUtil";

const CustomSelect = ({
  options,
  label,
  value,
  showDefaultOption,
  onChange,
  width,
  height,
  disabled,
  required,
  dataLoading,
  showRequired,
  labelColor,
  labelWeight
}) => {
  const empresa = useEmpresa();

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (required && showRequired && isEmptyValue(value)) {
      requireField();
    }
  }, [showRequired]); // eslint-disable-line react-hooks/exhaustive-deps

  const validate = async (valueField) => {
    try {
      if (required) {
        await validationSchemaRequired.validate({
          requiredField: valueField,
        });
      }
      setErrors({});
    } catch (error) {
      setErrors({ [error.path]: error.message });
    }
  };

  const requireField = async () => {
    try {
      await validationSchemaRequired.validate({
        requiredField: null,
      });
      setErrors({});
    } catch (error) {
      setErrors({ [error.path]: error.message });
    }
  };

  const handleChange = (event) => {
    const selectedValue = event.target.value;
    onChange(selectedValue);
    validate(selectedValue);
  };

  return (
    <>
      <CheckRender allowed={label}>
        <Label
          font={empresa?.LETRA_PRINCIPAL}
          color={labelColor}
          weight={labelWeight}
        >
          {label}
        </Label>
      </CheckRender>

      <CheckRender allowed={dataLoading}>
        <Spinner size={20} colorBorderTop={empresa?.COLOR_PRINCIPAL} />
      </CheckRender>

      <CheckRender allowed={!dataLoading}>
        <Select
          value={value || ''}
          onChange={handleChange}
          font={empresa?.LETRA_PRINCIPAL}
          width={width}
          height={height}
          disabled={disabled}
        >
          {showDefaultOption && (
            <option key={0} value={""}>
              {"Seleccionar"}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </Select>
      </CheckRender>
      {errors.requiredField && (
        <ErrorMessage>{errors.requiredField}</ErrorMessage>
      )}
    </>
  );
};

export default CustomSelect;
